import { render } from "./Giveaway.vue?vue&type=template&id=3f72de28&scoped=true&ts=true"
import script from "./Giveaway.vue?vue&type=script&lang=ts"
export * from "./Giveaway.vue?vue&type=script&lang=ts"

import "./Giveaway.vue?vue&type=style&index=0&id=3f72de28&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f72de28"]])

export default __exports__